class Flood {

    /**
     * @since 2.0.0
     * @param function callback is the functino to call when the gate opens
     * @param object context is the scope of our flood gate caller
     * @method constructor
     */
    constructor(callback, context) {

        // Declare and initialize
        this.callback = callback;
        this.context  = context;
        this.timer    = null;

    }

    /**
     * Let the caller know about the flood gate.
     *
     * @since 2.0.0
     * @method gate
     * @param int time is the duration of the gate
     * @return function A callable function limited by flood gates
     */
    gate(time) {

        // Give an anonymous function to call
        return () => {

            // Reset our stopwatch
            clearTimeout(this.timer);

            // Set up our clearable timer
            this.timer = setTimeout(
                () => { this.callback.apply(this.context); },
                time || 150
            );

        };

    }
}

export default Flood;